module.exports = __webpack_public_path__ + "img/h_hearts.79450e2e.png";